import { AgendaItemModel } from "models/AgendaItemModel";
import { NumberChoiceModel } from "models/ChoiceModel";
import { createContext } from "react";

export interface AgendaItemTypesContextProps {
  agendaItemTypes: NumberChoiceModel[];
  canEditPause: () => boolean;
  canEditCategory: () => boolean;
  getClassName: (item: AgendaItemModel) => string;
}

export const AgendaItemTypesContext = createContext({} as AgendaItemTypesContextProps);
